export const featureDataBuildingEnvelopeRenewals = {
    mainTitle: 'Why Choose HRD Painting & Restoration?',
    items: [
        {
            number: '01',
            heading: 'Over 20 years of expertise in high-rise restoration and exterior maintenance.'
        },
        {
            number: '02',
            heading: 'Premium materials and industry-leading techniques for long-lasting results.'
        },
        {
            number: '03',
            heading: 'Minimal disruption to occupants and business operations.'
        },
        {
            number: '04',
            heading: 'Commitment to safety, compliance, and environmental responsibility.'
        }
    ],
    title: "",
    subtitle:
        'By combining expert craftsmanship with cutting-edge materials, we deliver solutions that extend the life of your building while preserving its aesthetic appeal and functionality.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/1BuildingEnvelopeRenewals/featuregridSection/fondo.png'
};
